module.exports = __webpack_public_path__ + "media/application/images/blobs/blob_orange-07b51dff5590d31c97c479dc498ad4e6.png";